import sheet from '../assets/images/sheet.png'
import sparkleSheet from '../assets/images/sparkle.png'
import Effect from './effect'

const image = new Image()
image.src = sheet

const CropSheet = {
  CABBAGE_1: [0, 14],
  CABBAGE_2: [1, 14],
  CABBAGE_3: [2, 14],
  CABBAGE_4: [3, 14],

  STRAWBERRIES_1: [0, 13],
  STRAWBERRIES_2: [1, 13],
  STRAWBERRIES_3: [2, 13],
  STRAWBERRIES_4: [3, 13],

  WATERMELON_1: [0, 12],
  WATERMELON_2: [1, 12],
  WATERMELON_3: [2, 12],
  WATERMELON_4: [3, 12],

  WATER_INDICATOR_0: [0, 16],
  WATER_INDICATOR_1: [1, 16],
  WATER_INDICATOR_2: [2, 16],
  WATER_INDICATOR_3: [3, 16],
}

// time it takes for water to be used up
const WATER_TICK = 10
const GROW_TICK = 30

function Crop(x, y, type) {
  return kontra.sprite({
    x,
    y,
    type,
    growth: 1,
    water: 0,
    nextWaterTick: WATER_TICK,
    nextGrowTick: GROW_TICK * CropValue[type],
    nextSparkleTick: 0,
    beenWatered: false,

    update() {
      if (this.growth < 4 && this.water > 0) {
        this.beenWatered = true

        this.nextWaterTick--
        if (this.nextWaterTick <= 0) {
          this.water--
          this.nextWaterTick = WATER_TICK
        }

        if (this.water > 0) { 
          this.nextGrowTick--
          if (this.nextGrowTick <= 0) {
            this.growth++
            this.nextGrowTick = GROW_TICK * CropValue[type] / 2
          }
        }
      }
    },

    render() {
      const [sx, sy] = CropSheet[`${this.type}_${this.growth}`]
      this.context.drawImage(
        image,
        sx * 16, sy * 16, 16, 16,
        this.x, this.y, 16, 16
      )
        
      if (this.growth < 4) {
        // draw water indicator (unless its never been watered)
        if (this.beenWatered) {
          // const [sx, sy] = CropSheet[`WATER_INDICATOR_${this.water}`]
          this.context.drawImage(
            image,
            (7 - this.water) * 16, 16 * 16, 16, 16,
            this.x, this.y, 16, 16
          )
        }
      } else {
        // spawn sparkles to show ripeness
        this.nextSparkleTick--
        if (this.nextSparkleTick <= 0) {
          effects.push(Effect({
            minX: this.x,
            minY: this.y,
            maxX: this.x + GRID,
            maxY: this.y + GRID,
            effectType: Effects.SPARKLE
          }))
          this.nextSparkleTick = randomBetween(20, 40)
        }
      }
    }
  })
}

export default Crop